<template>
    <div class="main" v-loading='loading'>
        <div id="main" style="width: 800px;height:400px;"></div>
        <div id="main2" style="width: 1500px;height:400px;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { getOrder } from "../../api/api"
    export default {
        data() {
            return {
                loading:true,
                madrid_shop:[],//西
                cuirz:[],//西
                nihonbro:[],//日
                jleague_shop:[],//日
                supermaillot:[],//法
                fortmaillot:[],//法
                kickitshirts:[],//英
                mailloten:[],//英
                honorjersey:[],//英
                ligafoot:[],//法
                beazl:[],//西
                top_w:[]//日
            }
        },
        created () {
            
        },
        mounted () {
            var un = window.localStorage.getItem('un');
            if(un == '' || un == null || un == undefined){
                this.loading = true;
                return false;
            }
            var myChart = echarts.init(document.getElementById('main'));
            getOrder().then(res => {
                for(var i of res){
                    if(i.site == "madrid-shop"){
                        this.madrid_shop.push(i);
                    }else if(i.site == "cuirz"){
                        this.cuirz.push(i);
                    }else if(i.site == "nihonbro"){
                        this.nihonbro.push(i);
                    }else if(i.site == "jleague-shop"){
                        this.jleague_shop.push(i);
                    }else if(i.site == "supermaillot"){
                        this.supermaillot.push(i);
                    }else if(i.site == "fortmaillot"){
                        this.fortmaillot.push(i);
                    }else if(i.site == "kickitshirts"){
                        this.kickitshirts.push(i);
                    }else if(i.site == "mailloten"){
                        this.mailloten.push(i);
                    }else if(i.site == "honorjersey"){
                        this.honorjersey.push(i);
                    }else if(i.site == "ligafoot"){
                        this.ligafoot.push(i);
                    }else if(i.site == "beazl"){
                        this.beazl.push(i);
                    }else if(i.site == "top_w"){
                        this.top_w.push(i);
                    }
                }
                // console.log(`
                // ${this.madrid_shop.length},
                // ${this.cuirz.length},
                // ${this.nihonbro.length},
                // ${this.jleague_shop.length},
                // ${this.supermaillot.length},
                // ${this.fortmaillot.length},
                // ${this.kickitshirts.length},
                // ${this.mailloten.length},
                // ${this.honorjersey.length},
                // ${this.ligafoot.length},
                // ${this.beazl.length},
                // ${this.top_w.length},`);
                myChart.setOption({
                    series : [
                        {
                            name: '站点来源',
                            type: 'pie',    // 设置图表类型为饼图
                            radius: '55%',  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
                            // roseType: 'angle',
                            radius: ['40%', '70%'],
                            tooltip: {
                                trigger: 'item'
                            },
                            data:[          // 数据数组，name 为数据项名称，value 为数据项值
                                {value:this.madrid_shop.length, name:'madrid-shop'},
                                {value:this.cuirz.length, name:'cuirz'},
                                {value:this.nihonbro.length, name:'nihonbro'},
                                {value:this.jleague_shop.length, name:'jleague-shop'},
                                {value:this.supermaillot.length, name:'supermaillot'},
                                {value:this.fortmaillot.length, name:'fortmaillot'},
                                {value:this.kickitshirts.length, name:'kickitshirts'},
                                {value:this.mailloten.length, name:'mailloten'},
                                {value:this.beazl.length, name:'beazl'},
                                {value:this.honorjersey.length, name:'honorjersey'},
                                {value:this.top_w.length, name:'top-w'},
                                {value:this.ligafoot.length, name:'ligafoot'},
                            ]
                        }
                    ]
                });
                var myChart_ = echarts.init(document.getElementById('main2'));
                // 指定图表的配置项和数据
                var option = {
                    title: {
                        text: '各站点订单量'
                    },
                    tooltip: {},
                    legend: {
                        data:['订单量']
                    },
                    xAxis: {
                        data: ["madrid-shop","cuirz","nihonbro","jleague-shop","supermaillot","fortmaillot","kickitshirts","mailloten","honorjersey","ligafoot","beazl","top-w"]
                    },
                    yAxis: {},
                    series: [{
                        name: '订单量',
                        type: 'bar',
                        data: [this.madrid_shop.length, this.cuirz.length, this.nihonbro.length, this.jleague_shop.length, this.supermaillot.length, this.fortmaillot.length, this.kickitshirts.length, this.mailloten.length, this.honorjersey.length, this.ligafoot.length, this.beazl.length, this.top_w.length]
                    }]
                };
        
                // 使用刚指定的配置项和数据显示图表。
                myChart_.setOption(option);
                this.loading = false;
            })
        },
        methods: {
            name() {
                
            }
        },
    }
</script>

<style lang="scss" scoped>
.main > div{
    display: inline-block;
}
</style>